import { ApiConnectionUserMapping } from '@tassat/fred-extended-definitions';

import { APIConnectionUsersAgGrid } from './APIConnectionUsers';

export interface IAPIUsersAgGridProps{
    usersFromApiConnection: ApiConnectionUserMapping[];
    apiConnectionID: string;
}

export default APIConnectionUsersAgGrid;